import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// https://developer.mozilla.org/en-US/docs/Web/API/History/scrollRestoration#manual
window.history.scrollRestoration = 'manual';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
